<template>
<div class="image-input">
  <input type="file" class="form-control-file file-picker" aria-describedby="fileHelp" accept="image/*" @change="imageChanged" :ref="filePickerId">
  <input type="button" @click="openFilePicker" value="画像を選択…" class="select-button">
  <span v-show="fileName">{{ fileName }}</span>
  <div v-show="error" class="text-danger">{{ error }}</div>
  <a v-show="fileName" href="#" class="cancel-button" @click.prevent="cancel">取り消し</a>
</div>
</template>

<script>
import util from 'util/common'
export default {
  props: ['index', 'image'],

  data () {
    return {
      error: ''
    }
  },

  methods: {
    openFilePicker (e) {
      this.$refs[this.filePickerId].click()
    },
    imageChanged (e) {
      var file = e.target.files || e.dataTransfer.files
      if (file.length) {
        var reader = new FileReader()
        reader.onload = this.checkImage(file[0])
        reader.readAsDataURL(file[0])
      } else {
        this.$emit('image-changed', '')
      }
    },
    checkImage (file) {
      var self = this
      return function (e) {
        var img = new Image()
        img.src = e.target.result
        if (!self.isUploadableFile(file.name)) {
          self.error = '選択できるのは画像ファイル(jpg、png)のみです'
          self.cancel()
          return false
        }
        self.error = ''
        self.$emit('image-changed', file)
      }
    },
    cancel () {
      this.$refs[this.filePickerId].value = ''
      this.$emit('image-changed', '')
    },
    isUploadableFile (filename) {
      return filename.match(/.*\.(jpe?g|png|JPE?G|PNG)$/)
    }
  },

  computed: {
    filePickerId () {
      return 'file-picker-' + this.index
    },
    fileName () {
      return util.isFile(this.image)
      ? this.image.name // maybe image file
      : this.image // maybe URL
    }
  }
}
</script>

<style scoped>
.image-input {
  margin-bottom: 10px;
}
.image-input input.file-picker {
  display: none;
}
.image-input input.select-button {
  margin-right: 10px;
}
.image-input .cancel-button {
  margin-left: 20px;
}
</style>



// WEBPACK FOOTER //
// ImageInput.vue?3df2fec0